
import React, { useState } from "react";
import PropTypes from "prop-types";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { route } from "../../services/apiRoutes";
import {
  deleteBooking,
  setCheckFirstStepCompleted,
  setResetData,

  updateSaveForLaterVoucherForm,
} from "../../pages/voucher-form/voucher-form.slice";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SnackbarAlert from "../snackbar-alert/SnackbarAlert";
import { termsApiErrorMessage } from "../../utilis/common-funtions";
import { useVoucherFormMode } from "../../utilis/use-voucher-form-mode";
import "./common-button.scss";
const CommonButtonVoucherForm = ({
  handlePrevious,
  handleNext,
  isDisable,
  showPrevBtn,
  applicantNo,
  saveAndPreview,
  saveDraftData,
  fromPage,
  saveDraftPath,
  saveDraftMethod,
  saveForLater = true,
  hidePrevButton,
  isSubmit = false,
  isSendLink = false,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openApplicantCountModal, setOpenApplicantCountModal] = useState(false);
  const dispatch = useDispatch();
  const { voucherId } = useParams();
  const { isApplicantUpdateMode } = useVoucherFormMode();
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const {
    isLoading,
    applicantEditPreview,
    applicantTotal,
    unitPrefEditFromThankYou,
  } = useSelector((state) => state?.voucherForm);

  const isLastApplicant = applicantNo === (applicantTotal);
  const isFinalStep = fromPage === "professional" || (applicantNo > 2 && isLastApplicant);
  const isSubmitOrPreview = isFinalStep && isLastApplicant && (isApplicantUpdateMode || (applicantEditPreview && !unitPrefEditFromThankYou));

  const handleSaveDraft = () => {
    let payload = {
      // ...applicantData,
      ...saveDraftData,
      // lastStep: activeStep,
      // isCompleted: false,
      // saveForLater: true,
    };

    dispatch(
      // updateReviewDetails({
      //   path: `${route.UPDATE_APPLICANT_DATA}/${voucherId}`,
      //   payload: payload,
      // })
      updateSaveForLaterVoucherForm({
        path: saveDraftPath || `${route.UPDATE_VOUCHER_APPLICANT_DETAILS}/${voucherId}`,
        payload: payload,
        voucherId: voucherId,
        method: saveDraftMethod
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.data) {
          if (fromPage === "professional" && applicantNo === 1) {
            dispatch(setCheckFirstStepCompleted(true));
          }
          setOpenModal(!openModal);
        }
      })
      .catch((error) => {
        // handle error here
      });
  };

  const handleClearApplicantData = () => {
    setOpenApplicantCountModal(!openApplicantCountModal);
    let payload = {
      voucherId,
    };
    dispatch(deleteBooking(payload))
      .unwrap()
      .then((res) => {
        if (res?.statusCode === 200 || res?.statusCode === 201) {
          dispatch(setResetData());
          globalThis.location.href = `/booking-form/${voucherId}`;
        }
      })
      .catch((error) => {
        setSnackbarConfig({
          open: true,
          message: termsApiErrorMessage(error),
          severity: "error",
        });
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Box
        sx={{
          display: "flex",
          justifyContent: {
            xs: "center", // Center vertically on mobile
            sm: "space-between",
          },
          alignItems: "center",
          width: {
            xs: "100%", // Full width on mobile
            sm: "100%", // Slightly smaller width on tablets
            md: "100%", // Even smaller width on desktop
          },
          mt: {
            xs: "20px", // Margin top for mobile
            sm: "40px", // Margin top for tablets
            md: "60px", // Margin top for desktops
          },
          flexDirection: {
            xs: "column", // Stack vertically on mobile
            sm: "row", // Align horizontally on tablets and larger
          },
        }}
      >
        {saveForLater && (<Button
          startIcon={<BookmarkBorderIcon />}
          type="button"
          sx={{
            width: {
              xs: "200px",
              sm: "200px",
              md: "200px",
              lg: "200px",
            },
            height: "48px",
            borderRadius: "8px",
            background: "#fff",
            color: "#1A407D",
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "24px",
            textTransform: "capitalize",
            border: "1px solid #D0D5DD",
            "&:hover": {
              backgroundColor: "#092552",
              color: "#fff",
            },
            mb: {
              xs: "24px",
              sm: "0px",
              md: "0px",
              lg: "0px",
            },
          }}
          onClick={() => {
            handleSaveDraft();
          }}
        >
          Save as Draft
        </Button>)}

        <Box
          className="mobileBtnPreview"
          sx={{
            display: "flex",
            width: {
              xs: "100%",
            },
            justifyContent: {
              xs: "row",
              sm: "flex-end",
              md: "flex-end",
              lg: "flex-end",
            },
            flexDirection: {
              xs: "row",
              sm: "row",
              md: "row",
              lg: "row",
            },
            gap: {
              xs: "16px",
              md: "8px",
              lg: 2,
            },
          }}
        >

          <div className="mobilePrevNext">
            {!hidePrevButton && (
              <Button
                startIcon={
                  <Box
                    sx={{
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <NavigateNextIcon
                      sx={{
                        transform: "rotate(180deg)",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </Box>
                }
                type="button"
                sx={{
                  width: {
                    xs: "48%",
                    sm: "157px",
                    md: "157px",
                    lg: "157px",
                  },
                  height: "48px",
                  borderRadius: "8px",
                  background: "#fff",
                  color: "#1A407D",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textTransform: "capitalize",
                  border: "1px solid #D0D5DD",
                  "&:hover": {
                    backgroundColor: "#092552",
                    color: "#fff",
                  },
                }}
                onClick={() => {
                  if (showPrevBtn) {
                    setOpenApplicantCountModal(!openApplicantCountModal);
                  } else {
                    handlePrevious();
                  }
                }}
              >
                Previous
              </Button>
            )}

            <Button
              endIcon={
                !isSendLink && (
                  <Box
                    sx={{
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <NavigateNextIcon />
                  </Box>
                )
              }
              type="submit"
              disabled={isDisable}
              className={isDisable ? "disableCTA" : ""}
              sx={{
                width: {
                  xs: "157px",
                  sm: "157px",
                  md: "157px",
                  lg: "157px",
                },
                height: "48px",
                borderRadius: "8px",
                background: "#1A407D",
                color: "#fff",
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "24px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#092552",
                },
              }}
              onClick={() => {
                if (isSubmitOrPreview && saveAndPreview) {
                  saveAndPreview("save");
                } else {
                  handleNext("save");
                }
              }}
            >
              {(() => {
                if (isSendLink) return "Send Link";
                if (isSubmit) return "Submit";
                if (isSubmitOrPreview) {
                  if (isApplicantUpdateMode) return "Submit";
                  if (applicantEditPreview) return "Save & Preview";
                }
                return "Next";
              })()}
            </Button>
          </div>
        </Box>
      </Box>
      {openModal ? (
        <Modal
          open={openModal}
          onClose={() => {
            setOpenModal(!openModal);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="saveLaterModal"
          hideBackdrop={true}
          disableEscapeKeyDown={true}
        >
          <div className="modalContainer">
            <Box sx={{ border: "0" }}>
              <button
                className="resetButton closeModal"
                onClick={() => setOpenModal(!openModal)}
              >
                <HighlightOffIcon />
              </button>
              <Typography
                className="modalTitle"
                id="modal-modal-title"
                variant="h6"
                component="h2"
              >
                Draft saved!
              </Typography>
              <div className="titleDear marginTop">
                You can resume later using the link emailed to you.
                <br />
              </div>
              {/* <a className="linkText" href="https://www.puravankara.com/">
                  Link
                </a> */}
            </Box>
          </div>
        </Modal>
      ) : null}
      {openApplicantCountModal ? (
        <Modal
          open={openApplicantCountModal}
          onClose={() => {
            setOpenApplicantCountModal(!openApplicantCountModal);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="saveLaterModal"
          hideBackdrop={true}
          disableEscapeKeyDown={true}
        >
          <div className="modalContainer">
            <Box sx={{ border: "0" }}>
              <button
                className="resetButton closeModal"
                onClick={() =>
                  setOpenApplicantCountModal(!openApplicantCountModal)
                }
              >
                <HighlightOffIcon />
              </button>
              <Typography
                className="modalTitle"
                id="modal-modal-title"
                variant="h6"
                component="h2"
              >
                Do you want to change the number of applicants?
              </Typography>
              <div className="titleDear marginTop">
                Going back will delete all entered information. You'll need to
                reenter your details
                <br />
              </div>
            </Box>
            <div className="btnSignLateModal titleDear marginTop">
              <button
                onClick={() => {
                  handleClearApplicantData();
                }}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setOpenApplicantCountModal(!openApplicantCountModal);
                }}
              >
                No
              </button>
            </div>
          </div>
        </Modal>
      ) : null}
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};



CommonButtonVoucherForm.propTypes = {
  applicantNo: PropTypes.any,
  fromPage: PropTypes.any,
  handleNext: PropTypes.any,
  handlePrevious: PropTypes.any,
  hidePrevButton: PropTypes.bool,
  innerSteps: PropTypes.any,
  isDisable: PropTypes.bool,
  isSendLink: PropTypes.bool,
  isSubmit: PropTypes.bool,
  nextStep: PropTypes.any,
  saveAndPreview: PropTypes.any,
  saveDraftData: PropTypes.object,
  saveDraftMethod: PropTypes.func,
  saveDraftPath: PropTypes.any,
  saveForLater: PropTypes.any,
  showPrevBtn: PropTypes.bool,
};

export default CommonButtonVoucherForm;
